import React, { ReactNode } from "react"

import Container from "@ecom/ui/components/Container"
import clsx from "clsx"
import Card from "./Card"
import { CARDS_DEFAULT, type ICard } from "./helper"

import * as styles from "./gridWithTooltip.module.scss"

type Props = {
  headTitle?: ReactNode
  headDescr?: ReactNode
  dataContent?: ICard[]
  orderNum?: string
  variant?: string
}

export const GridWithTooltip = ({
  headTitle = "Больше выгоды",
  headDescr = "С подпиской «Халва.Десятка»",
  dataContent = CARDS_DEFAULT,
  orderNum,
  variant,
}: Props) => (
  <section
    className={clsx(styles.section, variant && styles[variant])}
    id="moreBenefits"
    data-exclude={orderNum}
  >
    <Container>
      <h2 className={styles.headTitle}>{headTitle}</h2>
      <div className={styles.headDescr}>{headDescr}</div>

      <div className={styles.grid}>
        {dataContent?.map((card, index) => (
          <Card key={index} {...card} />
        ))}
      </div>
    </Container>
  </section>
)
